import BackgroundHeader from './../images/header_back.png';
import BackgroundLogo from './../images/logo.png';
import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import { Link } from 'react-router-dom';
import MenuItem from 'material-ui/MenuItem';
import '../../css/dzbn.css';
import { withStyles } from '@material-ui/core/styles';
import IconNavBar from './IconNavBar';
import Typography from '@material-ui/core/Typography';
import { logout } from './../actions/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';

/*eslint-disable max-len,quotes*/

const styles = theme => ({
    subtitle2: {
        lineHeight: 4,
        fontSize: 17,
        fontFamily:'PT Sans Narrow, sans-serif',
    },
    navbarItem: {
        height: '60px',
        display: '-webkit-box',
        display: '-ms-flexbox',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '25px',
        paddingRight: '25px',
        "&:hover" : {
            background: '#69a1a4',
            cursor: 'pointer'
        },
        "&:active" : {
            background: '#69a1a4',
            cursor: 'pointer'
        }
    }
});

class Header extends React.Component{
    constructor(props) {
        super(props);
    }
     render() {
         const { classes, link } = this.props;
         return (
             <header style={{marginBottom:'20px'}}>
             <Grid container spacing={16}  className='logoBackground' style={{backgroundImage:`url(./dist/${BackgroundHeader})`, height:'145px', paddingLeft:'10%'}}>
                 <Grid item lg={12} xs={12}  className='mock'>
                             <a href="https://dkns.by/" onClick={this.handleLogout}>
                                 <img alt="dzbn.by" src={`/dist/${BackgroundLogo}`}/>
                             </a>
                             <div className='logoText'>
                                 <a onClick={this.handleLogout} style={{fontSize:'17px',color:"#424242",fontFamily:`"PT Sans Narrow", sans-serif`, textDecoration: 'none'}} href="https://dkns.by/" variant="body1" gutterBottom>
                                     Департамент контроля и надзора за строительством <br />
                                     Государственного комитета по стандартизации Республики Беларусь
                                 </a>
                             </div>
                     </Grid>
             </Grid>
                 <Grid container spacing={16} >
                     <Grid item lg={12} xs={12} className='wrapperNav' style={{paddingTop:'0px', width: '100%'}}>
                             <nav  style={{ marginLeft: '10%'}}>
                                 <li className={classes.navbarItem}>
                                     {link.to === "https://dkns.by/" && (<a href={link.to} isactive="true">
                                         <Typography variant="subtitle2" className={classes.subtitle2} gutterBottom><nobr>{link.title}</nobr></Typography>
                                     </a>)}
                                     {link.to !== "https://dkns.by/" &&  (<Link to={link.to} isactive="true">
                                         <Typography variant="subtitle2" className={classes.subtitle2} gutterBottom><nobr>{link.title}</nobr></Typography>
                                     </Link>)}
                                 </li>
                             </nav>
                     </Grid>
                 </Grid>
                 </header>);
     }



}

class OldHeader extends React.Component{
    constructor(props) {
        super(props);
    }

    handleLogout = () => {
        this.props.logout();
    }

    render(){
        const { classes, link } = this.props;
        return(
            <header>
                <div className='logoBackground' style={{backgroundImage:`url(./dist/${BackgroundHeader})`, height:'145px'}}>
                    <div className='mock'>
                        <a href="https://dkns.by/" onClick={this.handleLogout}>
                        <img alt="dzbn.by" src={`/dist/${BackgroundLogo}`}/>
                        </a>
                        <div className='logoText'>
                            <a onClick={this.handleLogout} style={{fontSize:'17px',color:"#424242",fontFamily:`"PT Sans Narrow", sans-serif`, textDecoration: 'none'}} href="https://dkns.by/" variant="body1" gutterBottom>
                                Департамент контроля и надзора за строительством <br />
                                Государственного комитета по стандартизации Республики Беларусь
                            </a>
                        </div>
                    </div>
                </div>
                <div className='wrapperNav'>
                    <nav>
                        <li className={classes.navbarItem}>
                            {link.to === "https://dkns.by/" && (<a href={link.to} isactive="true">
                                <Typography variant="subtitle2" className={classes.subtitle2} gutterBottom>{link.title}</Typography>
                            </a>)}
                            {link.to !== "https://dkns.by/" &&  (<Link to={link.to} isactive="true">
                                <Typography variant="subtitle2" className={classes.subtitle2} gutterBottom>{link.title}</Typography>
                            </Link>)}
                        </li>
                    </nav>
                </div>
            </header>
        )
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    link: PropTypes.object
}
Header.defaultProps = {
    link: {
        title: 'Публичный сайт',
        to: 'https://dkns.by/'
    }
}



function mapDispatch(dispatch) {
    return {
        logout: bindActionCreators(logout, dispatch)
    };
}

export default connect(mapDispatch)(withStyles(styles)(Header));



// WEBPACK FOOTER //
// ./assets/src/js/components/Header.jsx